export const initRem = () => {
  const designWidth = 375 // 设计稿宽度（pt）
  const baseFontSize = 37.5 // 基准字体大小（1rem = 100px）

  const setRootFontSize = () => {
    const clientWidth = document.documentElement.clientWidth
    // 计算根字体大小：实际宽度 / 设计稿宽度 × 基准字体大小
    const fontSize = (clientWidth / designWidth) * baseFontSize
    document.documentElement.style.fontSize = `${fontSize}px`
  }

  // 初始化并监听窗口变化
  setRootFontSize()
  window.addEventListener('resize', setRootFontSize)
}
